/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';

/**
 * 
 * @export
 * @interface TrackingShipmentProjection
 */
export interface TrackingShipmentProjection {
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof TrackingShipmentProjection
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {string}
     * @memberof TrackingShipmentProjection
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingShipmentProjection
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingShipmentProjection
     */
    trackingLink: string;
}

/**
 * Check if a given object implements the TrackingShipmentProjection interface.
 */
export function instanceOfTrackingShipmentProjection(value: object): value is TrackingShipmentProjection {
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('service' in value) || value['service'] === undefined) return false;
    if (!('trackingNumber' in value) || value['trackingNumber'] === undefined) return false;
    if (!('trackingLink' in value) || value['trackingLink'] === undefined) return false;
    return true;
}

export function TrackingShipmentProjectionFromJSON(json: any): TrackingShipmentProjection {
    return TrackingShipmentProjectionFromJSONTyped(json, false);
}

export function TrackingShipmentProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingShipmentProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'service': json['service'],
        'trackingNumber': json['trackingNumber'],
        'trackingLink': json['trackingLink'],
    };
}

export function TrackingShipmentProjectionToJSON(json: any): TrackingShipmentProjection {
    return TrackingShipmentProjectionToJSONTyped(json, false);
}

export function TrackingShipmentProjectionToJSONTyped(value?: TrackingShipmentProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'service': value['service'],
        'trackingNumber': value['trackingNumber'],
        'trackingLink': value['trackingLink'],
    };
}

